window.Studio407 = window.Studio407 || {};

(function (Studio) {
  'use strict';

  const EDIT_SESSION_KEY = 'studio407EditSession';

  function getEditSession() {
    try {
      const savedSession =
        sessionStorage.getItem(EDIT_SESSION_KEY);

      if (!savedSession) {
        return null;
      }

      const session = JSON.parse(savedSession);

      if (!session) {
        return null;
      }

      const lineKey =
        session.lineKey ||
        session.itemKey ||
        null;

      const hasPhotos =
        Array.isArray(session.photos) &&
        session.photos.length > 0;

      const hasProjectId =
        typeof session.projectId === 'string' &&
        session.projectId.trim() !== '';

      if (!lineKey || (!hasProjectId && !hasPhotos)) {
        return null;
      }

      session.lineKey = lineKey;

      return session;
    } catch (error) {
      console.error(
        '407 Studio: unable to read the edit session.',
        error
      );

      return null;
    }
  }

  function isCartEditMode() {
    const params =
      new URLSearchParams(window.location.search);

    return params.get('407_edit') === '1';
  }

  function updateRequiredPhotos(setSize) {
    const requiredPhotos =
      document.getElementById(
        'studio-required-photos'
      );

    if (requiredPhotos) {
      requiredPhotos.textContent = setSize;
    }
  }

  function openStudioModal(step) {
    const modal =
      document.querySelector('[data-407-modal]');

    if (!modal) {
      return false;
    }

    document.body.appendChild(modal);

    Studio.showStep(step || 'upload');

    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';

    return true;
  }

  function closeStudioModal() {
    const modal =
      document.querySelector('[data-407-modal]');

    Studio.destroyCropper();

    if (modal) {
      modal.classList.remove('is-open');
    }

    document.body.style.overflow = '';
  }

  async function restoreCartEditSession() {
    if (!isCartEditMode()) {
      return false;
    }

    const session = getEditSession();

    if (!session) {
      console.warn(
        '407 Studio: edit mode was requested, but no saved session was found.'
      );

      return false;
    }

    Studio.state.editSession = session;
    Studio.state.isEditingCartItem = true;
    Studio.state.editLineKey =
      session.lineKey || null;

    Studio.state.editVariantId =
      Number(session.variantId) || null;

    /*
     * Primero intenta restaurar el proyecto editable
     * completo guardado en IndexedDB.
     */
    if (
      session.projectId &&
      typeof Studio.restoreCartEditorProject ===
        'function'
    ) {
      try {
        const restored =
          await Studio.restoreCartEditorProject(
            session.projectId
          );

        if (restored) {
          /*
           * La sesión del carrito contiene la clave
           * actual de la línea de Shopify.
           */
          Studio.state.editSession = session;
          Studio.state.isEditingCartItem = true;

          Studio.state.editLineKey =
            session.lineKey ||
            Studio.state.editLineKey;

          Studio.state.editVariantId =
            Number(session.variantId) ||
            Studio.state.editVariantId;

          Studio.state.projectId =
            session.projectId;

          updateRequiredPhotos(
            Studio.state.setSize
          );

          Studio.renderGallery();

          return openStudioModal('gallery');
        }
      } catch (error) {
        console.error(
          '407 Studio: unable to restore the saved editable project.',
          error
        );
      }
    }

    /*
     * Respaldo para productos anteriores que solamente
     * contienen las URLs de las fotografías.
     */
    if (
      !Array.isArray(session.photos) ||
      !session.photos.length
    ) {
      console.warn(
        '407 Studio: no editable project or backup photos were found.'
      );

      alert(
        'We could not restore this photo project. Please return to the cart and try again.'
      );

      return false;
    }

    const sessionSetSize =
      Number(session.setSize);

    const photoCount =
      session.photos.length;

    Studio.state.setSize =
      sessionSetSize > 0
        ? sessionSetSize
        : photoCount;

    updateRequiredPhotos(
      Studio.state.setSize
    );

    Studio.initializeSlots();

    session.photos.forEach(
      function (photoUrl, index) {
        const slot =
          Studio.state.slots[index];

        if (!slot || !photoUrl) {
          return;
        }

        const cleanUrl =
          String(photoUrl).trim();

        slot.image = cleanUrl;
        slot.originalImage = cleanUrl;

        slot.existingUrl = cleanUrl;
        slot.remoteUrl = cleanUrl;
        slot.uploadedUrl = cleanUrl;

        slot.originalFile = null;
        slot.finalFile = null;

        slot.edited = false;
        slot.changed = false;
        slot.replaced = false;
      }
    );

    Studio.renderGallery();

    return openStudioModal('gallery');
  }

 function openNewStudioSession() {
  const modal =
    document.querySelector('[data-407-modal]');

  if (!modal) {
    console.error(
      '407 Studio: modal not found on product page.'
    );
    return;
  }

  /*
   * Restaurar la apariencia normal del producto.
   */
  modal.classList.remove('is-cart-edit');

  const uploadProgress = modal.querySelector(
    '[data-studio-progress="upload"]'
  );

  const editProgress = modal.querySelector(
    '[data-studio-progress="edit"]'
  );

  const previewProgress = modal.querySelector(
    '[data-studio-progress="preview"]'
  );

  if (uploadProgress) {
    uploadProgress.hidden = false;
    uploadProgress.classList.add('is-active');
  }

  if (editProgress) {
    editProgress.hidden = false;
    editProgress.textContent = 'Edit';
    editProgress.classList.remove('is-active');
  }

  if (previewProgress) {
    previewProgress.hidden = false;
    previewProgress.classList.remove('is-active');
  }

  const continueButton = modal.querySelector(
    '.studio-gallery__continue'
  );

  if (continueButton) {
    continueButton.textContent = 'Continue →';
  }

  const previewButton = modal.querySelector(
    '[data-preview-add-cart]'
  );

  if (previewButton) {
    previewButton.textContent = 'Add To Cart';
    previewButton.setAttribute(
      'aria-label',
      'Add magnets to cart'
    );
  }

  Studio.state.setSize =
    Studio.getSelectedSetSize();

  Studio.state.editSession = null;
  Studio.state.isEditingCartItem = false;
  Studio.state.editLineKey = null;
  Studio.state.editVariantId = null;
  Studio.state.projectId = null;

  updateRequiredPhotos(
    Studio.state.setSize
  );

  Studio.initializeSlots();
  Studio.renderGallery();

  openStudioModal('upload');
}


Studio.openCartEditor = async function(editSession) {
  if (!editSession) {
    return;
  }

  const modal =
    document.querySelector('[data-407-modal]');

  if (!modal) {
    console.error(
      '407 Studio: modal not found in cart.'
    );
    return;
  }

  /*
   * Activar modo edición del carrito.
   */
  modal.classList.add('is-cart-edit');

  Studio.state.editSession = editSession;
  Studio.state.isEditingCartItem = true;
  Studio.state.editLineKey =
    editSession.lineKey;

  Studio.state.editVariantId =
    Number(editSession.variantId) || null;

  Studio.state.projectId =
    editSession.projectId || null;

  /*
   * Mostrar solamente Edit en el progreso.
   */
  const uploadProgress = modal.querySelector(
    '[data-studio-progress="upload"]'
  );

  const editProgress = modal.querySelector(
    '[data-studio-progress="edit"]'
  );

  const previewProgress = modal.querySelector(
    '[data-studio-progress="preview"]'
  );

  if (uploadProgress) {
    uploadProgress.hidden = true;
    uploadProgress.classList.remove('is-active');
  }

  if (previewProgress) {
    previewProgress.hidden = true;
    previewProgress.classList.remove('is-active');
  }

  if (editProgress) {
    editProgress.hidden = false;
    editProgress.textContent = 'Edit';
    editProgress.classList.add('is-active');
  }

  const continueButton = modal.querySelector(
    '.studio-gallery__continue'
  );

  if (continueButton) {
    continueButton.textContent = 'Save Changes';
  }

  /*
   * Primero intenta restaurar el proyecto completo
   * guardado en IndexedDB.
   */
  if (
    editSession.projectId &&
    typeof Studio.restoreCartEditorProject === 'function'
  ) {
    try {
      const restored =
        await Studio.restoreCartEditorProject(
          editSession.projectId
        );

      if (restored) {
        Studio.state.editSession = editSession;
        Studio.state.isEditingCartItem = true;
        Studio.state.editLineKey =
          editSession.lineKey;

        Studio.state.editVariantId =
          Number(editSession.variantId) || null;

        Studio.state.projectId =
          editSession.projectId;

        updateRequiredPhotos(
          Studio.state.setSize
        );

        Studio.renderGallery();
        openStudioModal('gallery');

        return;
      }
    } catch (error) {
      console.error(
        '407 Studio: unable to restore the saved editable project.',
        error
      );
    }
  }

  /*
   * Respaldo usando las URLs guardadas en el carrito.
   */
  const photos =
    Array.isArray(editSession.photos)
      ? editSession.photos
      : [];

  if (!photos.length) {
    console.error(
      '407 Studio: no photos were found for this cart item.'
    );
    return;
  }

  Studio.state.setSize =
    Number(editSession.setSize) ||
    photos.length;

  updateRequiredPhotos(
    Studio.state.setSize
  );

  Studio.initializeSlots();

  photos.forEach(function(photo, index) {
    const slot =
      Studio.state.slots[index];

    if (!slot || !photo) {
      return;
    }

    const cleanPhoto =
      String(photo).trim();

    slot.image = cleanPhoto;
    slot.originalImage = cleanPhoto;

    slot.existingUrl = cleanPhoto;
    slot.remoteUrl = cleanPhoto;
    slot.uploadedUrl = cleanPhoto;

    slot.originalFile = null;
    slot.finalFile = null;

    slot.edited = false;
    slot.changed = false;
    slot.replaced = false;
  });

 Studio.renderGallery();
openStudioModal('gallery');
};

document.addEventListener(
  'click',
  function (event) {
      const openButton =
        event.target.closest(
          '[data-open-studio-modal]'
        );

      const closeButton =
        event.target.closest(
          '[data-407-close]'
        );

      const uploadButton =
        event.target.closest(
          '#studio-upload-button'
        );

      const addPhotoButton =
        event.target.closest(
          '[data-add-photo]'
        );

      const galleryCard =
        event.target.closest(
          '[data-slot-id]'
        );

      const editorBack =
        event.target.closest(
          '[data-editor-back]'
        );

      const editorSave =
        event.target.closest(
          '[data-editor-save]'
        );

      const rotateButton =
        event.target.closest(
          '[data-editor-rotate]'
        );

      const resetButton =
        event.target.closest(
          '[data-editor-reset]'
        );

      const replaceButton =
        event.target.closest(
          '[data-editor-replace]'
        );

      const continueButton =
        event.target.closest(
          '.studio-gallery__continue'
        );

      const previewBack =
        event.target.closest(
          '[data-preview-back]'
        );

      const previewAddCart =
        event.target.closest(
          '[data-preview-add-cart]'
        );

      if (openButton) {
        event.preventDefault();

        openNewStudioSession();
        return;
      }

      if (closeButton) {
        event.preventDefault();

        closeStudioModal();
        return;
      }

      if (uploadButton) {
        event.preventDefault();

        const input =
          document.getElementById(
            'studio-photo-upload'
          );

        if (input) {
          input.removeAttribute('data-slot');
          input.click();
        }

        return;
      }

      if (addPhotoButton) {
        event.preventDefault();

        const input =
          document.getElementById(
            'studio-photo-upload'
          );

        if (input) {
          input.dataset.slot =
            addPhotoButton.dataset.addPhoto;

          input.click();
        }

        return;
      }

      if (
        galleryCard &&
        galleryCard.querySelector('img')
      ) {
        event.preventDefault();

        const slotId = parseInt(
          galleryCard.dataset.slotId,
          10
        );

        Studio.openEditor(slotId);
        return;
      }

      if (editorBack) {
        event.preventDefault();

        Studio.destroyCropper();
        Studio.showStep('gallery');

        return;
      }

      if (rotateButton) {
        event.preventDefault();

        if (window.studioCropper) {
          window.studioCropper.rotate(90);
        }

        return;
      }

      if (resetButton) {
        event.preventDefault();

        Studio.resetEditorImage();
        return;
      }

      if (replaceButton) {
        event.preventDefault();

        const input =
          document.getElementById(
            'studio-replace-photo'
          );

        if (input) {
          input.click();
        }

        return;
      }

      if (editorSave) {
        event.preventDefault();

        Studio.saveEditorImage();
        return;
      }

     if (continueButton) {
  event.preventDefault();

  if (continueButton.disabled) {
    return;
  }

  if (Studio.state.isEditingCartItem) {
    Studio.addStudioToCart(continueButton);
    return;
  }

  Studio.renderPreview();
  Studio.showStep('preview');

  return;
}

      if (previewBack) {
        event.preventDefault();

        Studio.showStep('gallery');
        return;
      }

      if (previewAddCart) {
        event.preventDefault();

        Studio.addStudioToCart(
          previewAddCart
        );
      }
    }
  );

  document.addEventListener(
    'keydown',
    function (event) {
      if (event.key !== 'Escape') {
        return;
      }

      closeStudioModal();
    }
  );

  document.addEventListener(
    'change',
    async function (event) {
      if (
        event.target.id ===
        'studio-replace-photo'
      ) {
        const file =
          event.target.files &&
          event.target.files[0];

        await Studio.replaceEditorImage(file);

        event.target.value = '';
        return;
      }

      if (
        event.target.id !==
        'studio-photo-upload'
      ) {
        return;
      }

      const input = event.target;

      const targetSlot =
        input.dataset.slot !== undefined
          ? parseInt(
              input.dataset.slot,
              10
            )
          : null;

      const selectedFiles =
        Array.from(input.files || []);

      if (!selectedFiles.length) {
        return;
      }

      const files =
        targetSlot !== null
          ? selectedFiles.slice(0, 1)
          : selectedFiles.slice(
              0,
              Studio.state.setSize
            );

      try {
        if (targetSlot !== null) {
          const slot =
            Studio.state.slots[targetSlot];

          const file = files[0];

          if (slot && file) {
            const imageData =
              await Studio.readFileAsDataURL(
                file
              );

            Studio.revokePreviewUrl(
              slot.image
            );

            slot.originalFile = file;
            slot.originalImage = imageData;
            slot.image = imageData;
            slot.finalFile = null;

            /*
             * La fotografía fue reemplazada, por lo que
             * no debe reutilizarse la URL anterior.
             */
            slot.existingUrl = null;
            slot.remoteUrl = null;
            slot.uploadedUrl = null;

            slot.edited = false;
            slot.changed = true;
            slot.replaced = true;

            slot.cropData = null;
            slot.canvasData = null;
            slot.imageData = null;
            slot.containerData = null;
            slot.rotation = 0;
            slot.zoom = 1;
          }
        } else {
          for (const file of files) {
            const emptySlot =
              Studio.state.slots.find(
                function (slot) {
                  return slot.image === null;
                }
              );

            if (!emptySlot) {
              break;
            }

            const imageData =
              await Studio.readFileAsDataURL(
                file
              );

            emptySlot.originalFile = file;
            emptySlot.originalImage =
              imageData;

            emptySlot.image = imageData;
            emptySlot.finalFile = null;

            emptySlot.existingUrl = null;
            emptySlot.remoteUrl = null;
            emptySlot.uploadedUrl = null;

            emptySlot.edited = false;
            emptySlot.changed = true;
            emptySlot.replaced = false;

            emptySlot.cropData = null;
            emptySlot.canvasData = null;
            emptySlot.imageData = null;
            emptySlot.containerData = null;
            emptySlot.rotation = 0;
            emptySlot.zoom = 1;
          }
        }

        Studio.renderGallery();
        Studio.showStep('gallery');
      } catch (error) {
        console.error(
          '407 Studio: unable to load photo.',
          error
        );

        alert(
          'We could not load one of your photos. Please try again.'
        );
      } finally {
        input.value = '';
        input.removeAttribute('data-slot');
      }
    }
  );

  function initializeCartEditMode() {
    if (!isCartEditMode()) {
      return;
    }

    /*
     * Este pequeño retraso permite que los demás
     * archivos del Studio terminen de cargar.
     */
    window.setTimeout(
      async function () {
        try {
          await restoreCartEditSession();
        } catch (error) {
          console.error(
            '407 Studio: cart edit initialization failed.',
            error
          );
        }
      },
      150
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeCartEditMode
    );
  } else {
    initializeCartEditMode();
  }
})(window.Studio407);